import React from "react";
import noPageWrapper from "../../constants/noPageWrapper";
import BackgroundLayout from "../BackgroundLayout";
import Transition from "../../../client/common/Transition/Animation";
import Header from "../Header/Header";
import Footer from "../Footer";
import PropTypes from "prop-types";
import style from "./index.scss";

const PageWrapper = (props) => {
  const isProject = noPageWrapper.indexOf(window.location.pathname) != -1;
  return (
    <>
      {!isProject ? (
        <>
          <BackgroundLayout />
          <Transition>
            <div className={style["container"]}>
              <Header />
              {props.children}
            </div>
            <div className={style["footer"]}>
              <Footer />
            </div>
          </Transition>
        </>
      ) : (
        props.children
      )}
    </>
  );
};

PageWrapper.propTypes = {
  children: PropTypes.object.isRequired,
};

export default PageWrapper;
